/**
 * Excel Utils for Avalanche
 * MATCHES EXACT 72-COLUMN WEB UI STRUCTURE, DYNAMIC ALIGNMENT & DD/MM/YYYY DATES
 */

export const avalancheMISConfig = {
    dist_date: { title: 'DIST_DATE_AVALANCHE_REPORT', dateColumn: true, blockColumn: true, dateFirst: false },
    dist: { title: 'DIST_AVALANCHE_REPORT', dateColumn: false, blockColumn: true, dateFirst: false },
    state: { title: 'STATE_AVALANCHE_REPORT', dateColumn: false, blockColumn: false, dateFirst: false },
    state_date: { title: 'STATE_DATE_AVALANCHE_REPORT', dateColumn: true, blockColumn: false, dateFirst: true }
};

// 🔴 THE COMPLETE 72-COLUMN MAPPING IN EXACT WEB UI ORDER
export const AVALANCHE_MIS_FIELDS = [
    { api: 'no_of_incidents', label: 'Number of incidents (today)', isCum: false },
    { api: 'no_of_incidents_cum', label: 'Number of incidents (cumulative)', isCum: true },
    { api: 'address', label: 'Addresses of the places of incidents', isCum: false, isText: true },
    { api: 'no_of_human_deaths_today', label: 'Number of human deaths (today)', isCum: false },
    { api: 'no_of_cattle_deaths_today', label: 'Number of cattle deaths (today)', isCum: false },
    { api: 'no_of_poultry_deaths_today', label: 'Number of poultry deaths (today)', isCum: false },
    { api: 'no_of_human_deaths_cum', label: 'Number of human deaths (cumulative)', isCum: true },
    { api: 'no_of_cattle_deaths_cum', label: 'Number of cattle deaths (cumulative)', isCum: true },
    { api: 'no_of_poultry_deaths_cum', label: 'Number of poultry deaths (cumulative)', isCum: true },
    { api: 'no_of_human_injured_today', label: 'Number of humans injured (today)', isCum: false },
    { api: 'no_of_cattle_injured_today', label: 'Number of cattles injured (today)', isCum: false },
    { api: 'no_of_poultry_injured_today', label: 'Number of poultry injured (today)', isCum: false },
    { api: 'no_of_human_injured_cum', label: 'Number of humans injured (cumulative)', isCum: true },
    { api: 'no_of_cattle_injured_cum', label: 'Number of cattles injured (cumulative)', isCum: true },
    { api: 'no_of_poultry_injured_cum', label: 'Number of poultry injured (cumulative)', isCum: true },
    { api: 'no_of_deceased_pay_exgra_done_today', label: 'Number of deceased for whom payment of ex-gratia done (today)', isCum: false },
    { api: 'no_of_deceased_pay_exgra_done_cum', label: 'Number of deceased for whom payment of ex-gratia done (cumulative)', isCum: true },
    { api: 'no_of_dead_cattles_pay_done_today', label: 'No. of dead cattles for which payment done (today)', isCum: false },
    { api: 'no_of_dead_cattles_pay_done_cum', label: 'No. of dead cattles for which payment done (cumulative)', isCum: true },
    { api: 'no_of_dead_poultry_pay_done_today', label: 'Number of dead poultry for which payment done (today)', isCum: false },
    { api: 'no_of_dead_poultry_pay_done_cum', label: 'Number of dead poultry for which payment done (cumulative)', isCum: true },
    { api: 'concrete_complete', label: 'Number of concrete houses completely damaged (today)', isCum: false },
    { api: 'concrete_complete_cum', label: 'Number of concrete houses completely damaged (cumulative)', isCum: true },
    { api: 'concrete_partial', label: 'Number of concrete houses partially damaged (today)', isCum: false },
    { api: 'concrete_partial_cum', label: 'Number of concrete houses partially damaged (cumulative)', isCum: true },
    { api: 'kutcha_complete', label: 'Number of kutcha houses completely damaged (today)', isCum: false },
    { api: 'kutcha_complete_cum', label: 'Number of kutcha houses completely damaged (cumulative)', isCum: true },
    { api: 'kutcha_partial', label: 'Number of kutcha houses partially damaged (today)', isCum: false },
    { api: 'kutcha_partial_cum', label: 'Number of kutcha houses partially damaged (cumulative)', isCum: true },
    { api: 'cottage_hut', label: 'Number of cottages / huts damaged (today)', isCum: false },
    { api: 'cottage_hut_cum', label: 'Number of cottages / huts damaged (cumulative)', isCum: true },
    { api: 'total', label: 'Total number of damaged houses (today)', isCum: false },
    { api: 'total_cum', label: 'Total number of damaged houses (cumulative)', isCum: true },
    { api: 'concrete_complete_pay_done_today', label: 'Number of concrete houses completely damaged for which payment done (today)', isCum: false },
    { api: 'concrete_complete_pay_done_cum', label: 'Number of concrete houses completely damaged for which payment done (cumulative)', isCum: true },
    { api: 'concrete_partial_pay_done_today', label: 'Number of concrete houses partially damaged for which payment done (today)', isCum: false },
    { api: 'concrete_partial_pay_done_cum', label: 'Number of concrete houses partially damaged for which payment done (cumulative)', isCum: true },
    { api: 'kutcha_complete_pay_done_today', label: 'Number of kutcha houses completely damaged for which payment done (today)', isCum: false },
    { api: 'kutcha_complete_pay_done_cum', label: 'Number of kutcha houses completely damaged for which payment done (cumulative)', isCum: true },
    { api: 'kutcha_partial_pay_done_today', label: 'Number of kutcha houses partially damaged for which payment done (today)', isCum: false },
    { api: 'kutcha_partial_pay_done_cum', label: 'Number of kutcha houses partially damaged for which payment done (cumulative)', isCum: true },
    { api: 'cottage_hut_pay_done_today', label: 'Number of cottages / huts damaged for which payment done (today)', isCum: false },
    { api: 'cottage_hut_pay_done_cum', label: 'Number of cottages / huts damaged for which payment done (cumulative)', isCum: true },
    { api: 'today_pay_done_today', label: 'Total number of damaged houses for which payment done (today)', isCum: false },
    { api: 'today_pay_done_cum', label: 'Total number of damaged houses for which payment done (cumulative)', isCum: true },
    { api: 'no_of_dam_cattle_sheds_today', label: 'Number of damaged cattle sheds (today)', isCum: false },
    { api: 'no_of_dam_cattle_sheds_cum', label: 'Number of damaged cattle sheds (cumulative)', isCum: true },
    { api: 'no_of_dam_cattle_sheds_pay_done_today', label: 'Number of damaged cattle sheds for which payment done (today)', isCum: false },
    { api: 'no_of_dam_cattle_sheds_pay_done_cum', label: 'Number of damaged cattle sheds for which payment done (cumulative)', isCum: true },
    { api: 'amount_paid_dam_hous_hut_cattle_today', label: 'Amount paid against damaged house/hut/cattle shed (today) (rs.)', isCum: false },
    { api: 'amount_paid_dam_hous_hut_cattle_cum', label: 'Amount paid against damaged house/hut/cattle shed (cumulative) (rs.)', isCum: true },
    { api: 'damaged_crop_type', label: 'Damaged crop type (today)', isCum: false, isText: true },
    { api: 'damaged_crop_type_cum', label: 'Damaged crop type (cumulative)', isCum: true, isText: true },
    { api: 'damaged_crop_area_affected', label: 'Area of damaged crop (in acre) (today)', isCum: false },
    { api: 'damaged_crop_area_affected_cum', label: 'Area of damaged crop (in acre) (cumulative)', isCum: true },
    { api: 'estimated_value_of_damaged_crops_today', label: 'Estimated value of damaged crops (rs.) (today)', isCum: false },
    { api: 'estimated_value_of_damaged_crops_cum', label: 'Estimated value of damaged crops (rs.) (cumulative)', isCum: true },
    { api: 'area_crop_agricultural_input_sub_paid_today', label: 'Area of crop for which agriculture input subsidy paid (in acre) (today)', isCum: false },
    { api: 'area_crop_agricultural_input_sub_paid_cum', label: 'Area of crop for which agriculture input subsidy paid (in acre) (cumulative)', isCum: true },
    { api: 'amount_paid_agricultural_input_sub_today', label: 'Amount paid under the agriculture input subsidy (today)', isCum: false },
    { api: 'amount_paid_agricultural_input_sub_cum', label: 'Amount paid under the agriculture input subsidy (cumulative)', isCum: true },
    { api: 'total_amount_gr_paid_7k_per_fam_today', label: 'Total amount of gr paid @rs. 7000 per family (today)', isCum: false },
    { api: 'total_amount_gr_paid_7k_per_fam_cum', label: 'Total amount of gr paid @rs. 7000 per family (cumulative)', isCum: true },
    { api: 'total_amount_cloth_paid_5k_per_fam_today', label: 'Total amount paid for cloth/utensils etc., @5000 per family (today)', isCum: false },
    { api: 'total_amount_cloth_paid_5k_per_fam_cum', label: 'Total amount paid for cloth/utensils etc., @5000 per family (cumulative)', isCum: true },
    { api: 'number_of_polythene_sheets_distributed_today', label: 'Number of polythene sheets distributed (today)', isCum: false },
    { api: 'number_of_polythene_sheets_distributed_cum', label: 'Number of polythene sheets distributed (cumulative)', isCum: true },
    { api: 'quantity_dry_ration_distributed_today', label: 'Quantity of dry ration distributed (today)', isCum: false },
    { api: 'quantity_dry_ration_distributed_cum', label: 'Quantity of dry ration distributed (cumulative)', isCum: true },
    { api: 'remarks', label: 'Remarks', isCum: false, isText: true }
];

export const formatDateForDisplay = (dateStr) => {
  if (!dateStr) return 'N/A';
  if (typeof dateStr === 'number') {
      const date = new Date(dateStr);
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, '0');
      const d = String(date.getDate()).padStart(2, '0');
      return `${d}-${m}-${y}`; 
  }
  if (typeof dateStr === 'string') {
      if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
          const [y, m, d] = dateStr.split('-');
          return `${d}-${m}-${y}`;
      }
      if (/^\d{2}-\d{2}-\d{4}$/.test(dateStr)) {
          return dateStr;
      }
  }
  return String(dateStr);
};

// ✅ ADDED: Transformer for Status Excel (Name, Total Blocks, Submitted, Not Submitted)
export const transformStatusDataForExcel = (data, columnOrder) => {
    if (!data || data.length === 0) return { columns: [], transformedData: [] };
    const columnMapping = {
      dist_name: "Name",
      total_block_count: "Total Blocks",
      report_submitted: "Report Submitted",
      report_not_submitted: "Report Not Submitted",
    };
    const columns = (columnOrder || ['dist_name', 'total_block_count', 'report_submitted', 'report_not_submitted']).map(key => ({
      label: columnMapping[key] || key.toUpperCase().replace(/_/g, " "),
      key: key,
    }));
    const transformedData = data.map(row => {
      const transformedRow = {};
      columns.forEach(col => { transformedRow[col.label] = row[col.key] ?? "0"; });
      return transformedRow;
    });
    return { columns, transformedData };
};

export const transformAvalancheMISData = (rawData, viewType) => {
    let dailyRecords = [];
    if (Array.isArray(rawData)) dailyRecords = rawData;
    else if (rawData.mis_data) dailyRecords = rawData.mis_data.fire_report || rawData.mis_data.avalanche_report || [];
    else dailyRecords = rawData.fire_report || rawData.avalanche_report || [];

    // Sort by ascending date (Oldest to Newest)
    dailyRecords.sort((a, b) => {
        const valA = Number(a.reported_on) || 0;
        const valB = Number(b.reported_on) || 0;
        return valA - valB; 
    });

    let cumCumRecords = [];
    if (Array.isArray(rawData.cumulative_data)) cumCumRecords = rawData.cumulative_data;
    else if (rawData.cumulative_data) cumCumRecords = rawData.cumulative_data.fire_report_cum || rawData.cumulative_data.avalanche_report_cum || [];
    else if (rawData.mis_data) cumCumRecords = rawData.mis_data.fire_report_cum || rawData.mis_data.avalanche_report_cum || [];
    else cumCumRecords = rawData.fire_report_cum || rawData.avalanche_report_cum || [];

    const config = avalancheMISConfig[viewType] || avalancheMISConfig.dist_date;
    const getId = (obj) => obj.dist_id || obj.region_id || obj.block_id || obj.id || 'NA';

    const cumMap = {};
    if (cumCumRecords && cumCumRecords.length > 0) {
        cumCumRecords.forEach(r => {
            const id = getId(r);
            const dateKey = r.reported_on || 'NO_DATE';
            cumMap[`${id}_${dateKey}`] = r;
        });
    }

    // Build headers dynamically
    const headers = [];
    if (config.dateFirst) {
        if (config.dateColumn) headers.push('Date');
        headers.push('District Name');
    } else {
        headers.push('District Name');
        if (config.dateColumn) headers.push('Date');
    }
    if (config.blockColumn) headers.push('Block Name');
    
    AVALANCHE_MIS_FIELDS.forEach(field => headers.push(field.label));
    
    const rows = dailyRecords.map(rec => {
        const row = [];
        const id = getId(rec);
        const dateKey = rec.reported_on || 'NO_DATE';
        const cumRec = cumMap[`${id}_${dateKey}`] || {};

        if (config.dateFirst) {
            if (config.dateColumn) row.push(formatDateForDisplay(rec.reported_on));
            row.push(rec.dist_name || 'NA');
        } else {
            row.push(rec.dist_name || 'NA');
            if (config.dateColumn) row.push(formatDateForDisplay(rec.reported_on));
        }
        if (config.blockColumn) row.push(rec.block_name || 'NA');

        AVALANCHE_MIS_FIELDS.forEach(field => {
            if (field.isText) {
                row.push('NA');
            } else if (field.isCum) {
                let val = cumRec[field.api];
                row.push((val !== null && val !== undefined) ? val : 0);
            } else {
                let val = rec[field.api];
                row.push((val !== null && val !== undefined) ? val : 0);
            }
        });
        return row;
    });

    // Dynamic TOTAL Row protecting all Text Fields
    if (rows.length > 0 && !config.dateColumn) {
        const totalRow = Array(headers.length).fill('');
        
        headers.forEach((colName, index) => {
            if (colName === 'District Name') {
                totalRow[index] = 'TOTAL';
            } else if (
                colName === 'Date' || 
                colName === 'Block Name' || 
                colName === 'Addresses of the places of incidents' || 
                colName === 'Remarks' ||
                colName === 'Damaged crop type (today)' || 
                colName === 'Damaged crop type (cumulative)'
            ) {
                totalRow[index] = 'NA';
            } else {
                let sum = 0;
                rows.forEach(r => {
                    const val = parseFloat(r[index]);
                    if (!isNaN(val)) sum += val;
                });
                totalRow[index] = Number.isInteger(sum) ? sum : sum.toFixed(1);
            }
        });
        rows.push(totalRow);
    }

    return { headers, rows };
};